import { DiagnosticsStackDeviceMainStructure } from '../remote-diagnostics-topology.model';
import { DiagnosticsStackGenericResponse } from '../remote-diagnostics.model';

export const BusTopologyPhaseOne_vitodens300: DiagnosticsStackGenericResponse<
  DiagnosticsStackDeviceMainStructure[]
> = {
  type: 'BusTopologyPhaseOne',
  structure: [
    {
      TI: 'TI_7946868',
      name: 'Master Device',
      structure: [
        {
          RES: ' 62 01 79 37 39 34 36 38 36 38 31 30 31 30 30 34 31 32 37',
          request_parameter_name: 'PA_DataIdent',
          translationid: 'TI_LL_0000_Main_ECU_CAN01',
          service: 'DS_ReadDataByIdent',
          ecu: 'LL_0000_Main_ECU_CAN01',
          requestDate: '2023-04-21T11:52:21.135+0000',
          ecuvariant: 'LL_0000_Main_ECU_CAN01',
          request_parameter_value: 'ViessmannIdentificationNumber',
          securitystatus: 'ECU is unlocked !!!',
          type: 'ECU response structure by parameter name and value',
          structure: [
            {
              semantic: 'SERVICE-ID',
              path: 'PA_ServiID',
              unit: '',
              translationid: '',
              dopname: '',
              name: 'PA_ServiID',
              value: '98',
            },
            {
              semantic: '',
              path: 'PA_DataIdent',
              unit: '',
              translationid: '',
              dopname: '2 Byte Text Table VDD-Greenbook',
              name: 'PA_DataIdent',
              value: 'ViessmannIdentificationNumber',
            },
            {
              semantic: '',
              path: 'PA_DataRecor',
              translationid: '',
              dopname: '2 Byte Table VDD Greenbook',
              name: 'PA_DataRecor',
              structure: [
                {
                  semantic: 'ITEMID',
                  path: 'PA_DataRecor/PA_ItemId',
                  unit: '',
                  translationid: 'TI_ItemId',
                  dopname: '7 Byte Identical ItemId',
                  name: 'PA_ItemId',
                  value: '7946868',
                },
                {
                  semantic: 'PRODUCTIONYEAR',
                  path: 'PA_DataRecor/PA_Year',
                  unit: '',
                  translationid: 'TI_Year',
                  dopname: '1 Byte Identical uint8 ASCII',
                  name: 'PA_Year',
                  value: '1',
                },
                {
                  semantic: 'COUNTER',
                  path: 'PA_DataRecor/PA_ProceCount',
                  unit: '',
                  translationid: 'TI_ProcessCounter',
                  dopname: '5 Byte Identical ProcessCounter',
                  name: 'PA_ProceCount',
                  value: '01004',
                },
                {
                  semantic: 'COUNTER',
                  path: 'PA_DataRecor/PA_OverfCountOne',
                  unit: '',
                  translationid: 'TI_OverflowCounterOne',
                  dopname: '1 Byte Identical uint8 ASCII',
                  name: 'PA_OverfCountOne',
                  value: '1',
                },
                {
                  semantic: 'COUNTER',
                  path: 'PA_DataRecor/PA_OverfTwo',
                  unit: '',
                  translationid: 'TI_OverflowTwo',
                  dopname: '1 Byte Identical uint8 ASCII',
                  name: 'PA_OverfTwo',
                  value: '2',
                },
                {
                  semantic: 'VALUE',
                  path: 'PA_DataRecor/PA_Check',
                  unit: '',
                  translationid: 'TI_Checksum',
                  dopname: '1 Byte Identical uint8 ASCII',
                  name: 'PA_Check',
                  value: '7',
                },
              ],
            },
            {
              semantic: '',
              path: 'PA_RecorDataIdentCheck',
              unit: '',
              translationid: '',
              dopname: '',
              name: 'PA_RecorDataIdentCheck',
              value: '',
            },
          ],
          REQ: ' 22 01 79',
        },
        {
          name: 'Main ECU',
          structure: [
            {
              path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent[0]',
              logicallinkname: 'LL_0002_HMU_CAN01',
              translationid: 'TI_LL_0002_HMU_CAN01',
              isknownlink: 'true',
              vddname: 'BusTopologyMatrix',
              variantname: '5162110_608300',
              isonlinelink: 'true',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent',
                  translationid: '',
                  dopname: '36 Byte Structure BusIdentification',
                  name: 'STR_36ByteStrucBusIdent',
                  structure: [
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '1',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      TI_texttableentry: 'TI_CanInternal',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'CanInternal',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicObjecPrope',
                      unit: '',
                      translationid: 'TI_DeviceObjectProperty',
                      TI_texttableentry: 'TI_HMUMaster',
                      dopname: '1 Byte TextTable DeviceObjectProperty',
                      name: 'PA_DevicObjecPrope',
                      value: 'HMUMaster',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct',
                      translationid: 'TI_DeviceFunction',
                      dopname: '1 Byte Table DeviceObjectProperty',
                      name: 'PA_DevicFunct',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct/PA_DevicFunct',
                          unit: '',
                          translationid: 'TI_DeviceFunction',
                          TI_texttableentry: 'TI_VitodensThreeHundred',
                          dopname: '1 Byte TextTable uint8 HMUDeviceFunction',
                          name: 'PA_DevicFunct',
                          value: 'VitodensThreeHundred',
                        },
                      ],
                    },
                    {
                      semantic: 'SOFTWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi',
                      translationid: 'TI_SoftwareVersion',
                      dopname: '8 Byte Structure SoftwareVersion',
                      name: 'PA_SoftwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '2',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '516',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '2110',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Build',
                          unit: '',
                          translationid: 'TI_Build',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Build',
                          value: '507',
                        },
                      ],
                    },
                    {
                      semantic: 'HARDWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi',
                      translationid: 'TI_HardwareVersion',
                      dopname: '8 Byte Structure HardwareVersion',
                      name: 'PA_HardwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '2',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '608',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '300',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_AssemVaria',
                          unit: '',
                          translationid: 'TI_AssemblyVariant',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_AssemVaria',
                          value: '2',
                        },
                      ],
                    },
                    {
                      semantic: 'TARCEABILITY',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe',
                      translationid: 'TI_ElectronicTraceabilityNumber',
                      dopname: '16 Byte Structure VinModul',
                      name: 'PA_ElectTraceNumbe',
                      structure: [
                        {
                          semantic: 'ITEMID',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ItemId',
                          unit: '',
                          translationid: 'TI_ItemId',
                          dopname: '7 Byte Identical ItemId',
                          name: 'PA_ItemId',
                          value: '7632995',
                        },
                        {
                          semantic: 'PRODUCTIONYEAR',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Year',
                          unit: '',
                          translationid: 'TI_Year',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Year',
                          value: '1',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ProceCount',
                          unit: '',
                          translationid: 'TI_ProcessCounter',
                          dopname: '5 Byte Identical ProcessCounter',
                          name: 'PA_ProceCount',
                          value: '31384',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfCountOne',
                          unit: '',
                          translationid: 'TI_OverflowCounterOne',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfCountOne',
                          value: '1',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfTwo',
                          unit: '',
                          translationid: 'TI_OverflowTwo',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfTwo',
                          value: '2',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Check',
                          unit: '',
                          translationid: 'TI_Checksum',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Check',
                          value: '1',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          name: 'Additional ECUs',
          structure: [
            {
              path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent[1]',
              logicallinkname: 'LL_0001_BCU_CAN50',
              translationid: 'TI_LL_0001_BCU_CAN50',
              isknownlink: 'true',
              vddname: 'BusTopologyMatrix',
              variantname: '5202109_501400',
              isonlinelink: 'true',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent',
                  translationid: '',
                  dopname: '36 Byte Structure BusIdentification',
                  name: 'STR_36ByteStrucBusIdent',
                  structure: [
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '50',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      TI_texttableentry: 'TI_CanInternal',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'CanInternal',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicObjecPrope',
                      unit: '',
                      translationid: 'TI_DeviceObjectProperty',
                      TI_texttableentry: 'TI_BCU',
                      dopname: '1 Byte TextTable DeviceObjectProperty',
                      name: 'PA_DevicObjecPrope',
                      value: 'BCU',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct',
                      translationid: 'TI_DeviceFunction',
                      dopname: '1 Byte Table DeviceObjectProperty',
                      name: 'PA_DevicFunct',
                      structure: [
                        {
                          semantic: 'BOOLEANCHOICE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct/PA_Value',
                          unit: '',
                          translationid: 'TI_Value',
                          TI_texttableentry: 'TI_No',
                          dopname: '1 Byte TextTable NoYes',
                          name: 'PA_Value',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'SOFTWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi',
                      translationid: 'TI_SoftwareVersion',
                      dopname: '8 Byte Structure SoftwareVersion',
                      name: 'PA_SoftwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '1',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '520',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '2109',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Build',
                          unit: '',
                          translationid: 'TI_Build',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Build',
                          value: '157',
                        },
                      ],
                    },
                    {
                      semantic: 'HARDWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi',
                      translationid: 'TI_HardwareVersion',
                      dopname: '8 Byte Structure HardwareVersion',
                      name: 'PA_HardwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '1',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '501',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '400',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_AssemVaria',
                          unit: '',
                          translationid: 'TI_AssemblyVariant',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_AssemVaria',
                          value: '2',
                        },
                      ],
                    },
                    {
                      semantic: 'TARCEABILITY',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe',
                      translationid: 'TI_ElectronicTraceabilityNumber',
                      dopname: '16 Byte Structure VinModul',
                      name: 'PA_ElectTraceNumbe',
                      structure: [
                        {
                          semantic: 'ITEMID',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ItemId',
                          unit: '',
                          translationid: 'TI_ItemId',
                          dopname: '7 Byte Identical ItemId',
                          name: 'PA_ItemId',
                          value: '7633528',
                        },
                        {
                          semantic: 'PRODUCTIONYEAR',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Year',
                          unit: '',
                          translationid: 'TI_Year',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Year',
                          value: '1',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ProceCount',
                          unit: '',
                          translationid: 'TI_ProcessCounter',
                          dopname: '5 Byte Identical ProcessCounter',
                          name: 'PA_ProceCount',
                          value: '35933',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfCountOne',
                          unit: '',
                          translationid: 'TI_OverflowCounterOne',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfCountOne',
                          value: '1',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfTwo',
                          unit: '',
                          translationid: 'TI_OverflowTwo',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfTwo',
                          value: '2',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Check',
                          unit: '',
                          translationid: 'TI_Checksum',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Check',
                          value: '0',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent[3]',
              logicallinkname: 'LL_0003_HMI_CAN59',
              translationid: 'TI_LL_0003_HMI_CAN59',
              isknownlink: 'true',
              vddname: 'BusTopologyMatrix',
              variantname: '5272136_6553565535',
              isonlinelink: 'true',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent',
                  translationid: '',
                  dopname: '36 Byte Structure BusIdentification',
                  name: 'STR_36ByteStrucBusIdent',
                  structure: [
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '59',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      TI_texttableentry: 'TI_CanInternal',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'CanInternal',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicObjecPrope',
                      unit: '',
                      translationid: 'TI_DeviceObjectProperty',
                      TI_texttableentry: 'TI_HMI',
                      dopname: '1 Byte TextTable DeviceObjectProperty',
                      name: 'PA_DevicObjecPrope',
                      value: 'HMI',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct',
                      translationid: 'TI_DeviceFunction',
                      dopname: '1 Byte Table DeviceObjectProperty',
                      name: 'PA_DevicFunct',
                      structure: [
                        {
                          semantic: 'BOOLEANCHOICE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct/PA_Value',
                          unit: '',
                          translationid: 'TI_Value',
                          TI_texttableentry: 'TI_No',
                          dopname: '1 Byte TextTable NoYes',
                          name: 'PA_Value',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'SOFTWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi',
                      translationid: 'TI_SoftwareVersion',
                      dopname: '8 Byte Structure SoftwareVersion',
                      name: 'PA_SoftwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '3',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '527',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '2136',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Build',
                          unit: '',
                          translationid: 'TI_Build',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Build',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'HARDWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi',
                      translationid: 'TI_HardwareVersion',
                      dopname: '8 Byte Structure HardwareVersion',
                      name: 'PA_HardwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '65535',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '65535',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '65535',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_AssemVaria',
                          unit: '',
                          translationid: 'TI_AssemblyVariant',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_AssemVaria',
                          value: '65535',
                        },
                      ],
                    },
                    {
                      semantic: 'TARCEABILITY',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe',
                      translationid: 'TI_ElectronicTraceabilityNumber',
                      dopname: '16 Byte Structure VinModul',
                      name: 'PA_ElectTraceNumbe',
                      structure: [
                        {
                          semantic: 'ITEMID',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ItemId',
                          unit: '',
                          translationid: 'TI_ItemId',
                          dopname: '7 Byte Identical ItemId',
                          name: 'PA_ItemId',
                          value: '�������',
                        },
                        {
                          semantic: 'PRODUCTIONYEAR',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Year',
                          unit: '',
                          translationid: 'TI_Year',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Year',
                          value: 'ÿ',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ProceCount',
                          unit: '',
                          translationid: 'TI_ProcessCounter',
                          dopname: '5 Byte Identical ProcessCounter',
                          name: 'PA_ProceCount',
                          value: '�����',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfCountOne',
                          unit: '',
                          translationid: 'TI_OverflowCounterOne',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfCountOne',
                          value: 'ÿ',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfTwo',
                          unit: '',
                          translationid: 'TI_OverflowTwo',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfTwo',
                          value: 'ÿ',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Check',
                          unit: '',
                          translationid: 'TI_Checksum',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Check',
                          value: 'ÿ',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent[4]',
              logicallinkname: 'LL_0010_WiFi_CAN58',
              translationid: 'TI_LL_0010_WiFi_CAN58',
              isknownlink: 'true',
              vddname: 'BusTopologyMatrix',
              variantname: '5042113_0102',
              isonlinelink: 'true',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent',
                  translationid: '',
                  dopname: '36 Byte Structure BusIdentification',
                  name: 'STR_36ByteStrucBusIdent',
                  structure: [
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '58',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      TI_texttableentry: 'TI_CanInternal',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'CanInternal',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicObjecPrope',
                      unit: '',
                      translationid: 'TI_DeviceObjectProperty',
                      TI_texttableentry: 'TI_BackendGateway',
                      dopname: '1 Byte TextTable DeviceObjectProperty',
                      name: 'PA_DevicObjecPrope',
                      value: 'BackendGateway',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct',
                      translationid: 'TI_DeviceFunction',
                      dopname: '1 Byte Table DeviceObjectProperty',
                      name: 'PA_DevicFunct',
                      structure: [
                        {
                          semantic: 'ENUM',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct/PA_BackeGatew',
                          unit: '',
                          translationid: 'TI_BackendGateway',
                          TI_texttableentry: 'TI_Nothing',
                          dopname: '1 Byte TextTable BackendGateway',
                          name: 'PA_BackeGatew',
                          value: 'Nothing',
                        },
                      ],
                    },
                    {
                      semantic: 'SOFTWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi',
                      translationid: 'TI_SoftwareVersion',
                      dopname: '8 Byte Structure SoftwareVersion',
                      name: 'PA_SoftwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '10',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '504',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '2113',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Build',
                          unit: '',
                          translationid: 'TI_Build',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Build',
                          value: '2',
                        },
                      ],
                    },
                    {
                      semantic: 'HARDWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi',
                      translationid: 'TI_HardwareVersion',
                      dopname: '8 Byte Structure HardwareVersion',
                      name: 'PA_HardwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '10',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '1',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '2',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_AssemVaria',
                          unit: '',
                          translationid: 'TI_AssemblyVariant',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_AssemVaria',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'TARCEABILITY',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe',
                      translationid: 'TI_ElectronicTraceabilityNumber',
                      dopname: '16 Byte Structure VinModul',
                      name: 'PA_ElectTraceNumbe',
                      structure: [
                        {
                          semantic: 'ITEMID',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ItemId',
                          unit: '',
                          translationid: 'TI_ItemId',
                          dopname: '7 Byte Identical ItemId',
                          name: 'PA_ItemId',
                          value: '7782093',
                        },
                        {
                          semantic: 'PRODUCTIONYEAR',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Year',
                          unit: '',
                          translationid: 'TI_Year',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Year',
                          value: '0',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ProceCount',
                          unit: '',
                          translationid: 'TI_ProcessCounter',
                          dopname: '5 Byte Identical ProcessCounter',
                          name: 'PA_ProceCount',
                          value: '03786',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfCountOne',
                          unit: '',
                          translationid: 'TI_OverflowCounterOne',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfCountOne',
                          value: '1',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfTwo',
                          unit: '',
                          translationid: 'TI_OverflowTwo',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfTwo',
                          value: '8',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Check',
                          unit: '',
                          translationid: 'TI_Checksum',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Check',
                          value: '3',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          name: 'Accessories',
          structure: [
            {
              path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent[0]',
              logicallinkname: 'LL_0005_ADIO_PlusBus01',
              address: '1',
              translationid: 'TI_LL_0005_ADIO_PlusBus01',
              isknownlink: 'true',
              vddname: 'BusTopologyMatrixTwo',
              variantname: '50102_0101',
              isonlinelink: 'true',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent',
                  translationid: '',
                  dopname: '36 Byte Structure BusIdentification',
                  name: 'STR_36ByteStrucBusIdent',
                  structure: [
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '1',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      TI_texttableentry: 'TI_PlusBus',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'PlusBus',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicObjecPrope',
                      unit: '',
                      translationid: 'TI_DeviceObjectProperty',
                      TI_texttableentry: 'TI_ADIO',
                      dopname: '1 Byte TextTable DeviceObjectProperty',
                      name: 'PA_DevicObjecPrope',
                      value: 'ADIO',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct',
                      translationid: 'TI_DeviceFunction',
                      dopname: '1 Byte Table DeviceObjectProperty',
                      name: 'PA_DevicFunct',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct/PA_Value',
                          unit: '',
                          translationid: 'TI_Value',
                          TI_texttableentry: 'TI_MixerCircuitWithHydraulicSeparatorSensor',
                          dopname: '1 Byte TextTable GenericAnalogDigitalAccessoryFunction',
                          name: 'PA_Value',
                          value: 'MixerCircuitWithHydraulicSeparatorSensor',
                        },
                      ],
                    },
                    {
                      semantic: 'SOFTWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi',
                      translationid: 'TI_SoftwareVersion',
                      dopname: '8 Byte Structure SoftwareVersion',
                      name: 'PA_SoftwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '5',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '501',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '2',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Build',
                          unit: '',
                          translationid: 'TI_Build',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Build',
                          value: '100',
                        },
                      ],
                    },
                    {
                      semantic: 'HARDWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi',
                      translationid: 'TI_HardwareVersion',
                      dopname: '8 Byte Structure HardwareVersion',
                      name: 'PA_HardwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '65535',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '1',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '1',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_AssemVaria',
                          unit: '',
                          translationid: 'TI_AssemblyVariant',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_AssemVaria',
                          value: '65535',
                        },
                      ],
                    },
                    {
                      semantic: 'TARCEABILITY',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe',
                      translationid: 'TI_ElectronicTraceabilityNumber',
                      dopname: '16 Byte Structure VinModul',
                      name: 'PA_ElectTraceNumbe',
                      structure: [
                        {
                          semantic: 'ITEMID',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ItemId',
                          unit: '',
                          translationid: 'TI_ItemId',
                          dopname: '7 Byte Identical ItemId',
                          name: 'PA_ItemId',
                          value: '',
                        },
                        {
                          semantic: 'PRODUCTIONYEAR',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Year',
                          unit: '',
                          translationid: 'TI_Year',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Year',
                          value: '\b',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ProceCount',
                          unit: '',
                          translationid: 'TI_ProcessCounter',
                          dopname: '5 Byte Identical ProcessCounter',
                          name: 'PA_ProceCount',
                          value: '\u0001',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfCountOne',
                          unit: '',
                          translationid: 'TI_OverflowCounterOne',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfCountOne',
                          value: '\u0001',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfTwo',
                          unit: '',
                          translationid: 'TI_OverflowTwo',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfTwo',
                          value: '',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Check',
                          unit: '',
                          translationid: 'TI_Checksum',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Check',
                          value: '',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent[1]',
              logicallinkname: 'LL_0005_ADIO_PlusBus02',
              address: '2',
              translationid: 'TI_LL_0005_ADIO_PlusBus02',
              isknownlink: 'true',
              vddname: 'BusTopologyMatrixTwo',
              variantname: '50102_0101',
              isonlinelink: 'true',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent',
                  translationid: '',
                  dopname: '36 Byte Structure BusIdentification',
                  name: 'STR_36ByteStrucBusIdent',
                  structure: [
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '2',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      TI_texttableentry: 'TI_PlusBus',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'PlusBus',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicObjecPrope',
                      unit: '',
                      translationid: 'TI_DeviceObjectProperty',
                      TI_texttableentry: 'TI_ADIO',
                      dopname: '1 Byte TextTable DeviceObjectProperty',
                      name: 'PA_DevicObjecPrope',
                      value: 'ADIO',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct',
                      translationid: 'TI_DeviceFunction',
                      dopname: '1 Byte Table DeviceObjectProperty',
                      name: 'PA_DevicFunct',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct/PA_Value',
                          unit: '',
                          translationid: 'TI_Value',
                          TI_texttableentry: 'TI_MixerCircuitWithoutHydraulicSeparatorSensor',
                          dopname: '1 Byte TextTable GenericAnalogDigitalAccessoryFunction',
                          name: 'PA_Value',
                          value: 'MixerCircuitWithoutHydraulicSeparatorSensor',
                        },
                      ],
                    },
                    {
                      semantic: 'SOFTWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi',
                      translationid: 'TI_SoftwareVersion',
                      dopname: '8 Byte Structure SoftwareVersion',
                      name: 'PA_SoftwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '5',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '501',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '2',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Build',
                          unit: '',
                          translationid: 'TI_Build',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Build',
                          value: '100',
                        },
                      ],
                    },
                    {
                      semantic: 'HARDWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi',
                      translationid: 'TI_HardwareVersion',
                      dopname: '8 Byte Structure HardwareVersion',
                      name: 'PA_HardwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '65535',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '1',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '1',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_AssemVaria',
                          unit: '',
                          translationid: 'TI_AssemblyVariant',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_AssemVaria',
                          value: '65535',
                        },
                      ],
                    },
                    {
                      semantic: 'TARCEABILITY',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe',
                      translationid: 'TI_ElectronicTraceabilityNumber',
                      dopname: '16 Byte Structure VinModul',
                      name: 'PA_ElectTraceNumbe',
                      structure: [
                        {
                          semantic: 'ITEMID',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ItemId',
                          unit: '',
                          translationid: 'TI_ItemId',
                          dopname: '7 Byte Identical ItemId',
                          name: 'PA_ItemId',
                          value: '',
                        },
                        {
                          semantic: 'PRODUCTIONYEAR',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Year',
                          unit: '',
                          translationid: 'TI_Year',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Year',
                          value: '\b',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ProceCount',
                          unit: '',
                          translationid: 'TI_ProcessCounter',
                          dopname: '5 Byte Identical ProcessCounter',
                          name: 'PA_ProceCount',
                          value: '\u0001',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfCountOne',
                          unit: '',
                          translationid: 'TI_OverflowCounterOne',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfCountOne',
                          value: '\u0001',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfTwo',
                          unit: '',
                          translationid: 'TI_OverflowTwo',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfTwo',
                          value: '',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Check',
                          unit: '',
                          translationid: 'TI_Checksum',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Check',
                          value: '',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          name: 'OfflineECUs',
          structure: [
            {
              logicallinkname: 'LL_0019_WiFi_CAN58',
              translationid: 'TI_LL_0019_WiFi_CAN58',
              isknownlink: 'true',
              isonlinelink: 'false',
            },
            {
              logicallinkname: 'LL_0000_GasAirRatioSystem_CAN60',
              translationid: 'TI_LL_0000_GasAirRatioSystem_CAN60',
              isknownlink: 'true',
              isonlinelink: 'false',
            },
            {
              logicallinkname: 'LL_0018_HMI_CAN59',
              translationid: 'TI_LL_0018_HMI_CAN59',
              isknownlink: 'true',
              isonlinelink: 'false',
            },
          ],
        },
        {
          request_parameter_name: 'PA_ItemNumbe',
          translationid: 'TI_LL_0000_Main_ECU_CAN01',
          service: 'DS_ProduDefin',
          ecu: 'LL_0000_Main_ECU_CAN01',
          bundleID: 'B_00002_VD300',
          request_parameter_value: '7946868',
          type: 'RequestStructureByParameterNameAndValue',
        },
      ],
    },
  ],
};
